<template>
	<div class="module-card">
		<v-card>
			<v-card-title :style="{opacity: !owned ? 0.5 : 1}">
				<v-row no-gutters>
					<v-col class="text-truncate px-1">
						<span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'title'">{{moduleName}}</span>
						<v-chip class="ml-2" v-if="owned" small><translate>Active</translate></v-chip>
					</v-col>
					<v-tooltip top>
						<template v-slot:activator="{ on }">
							<v-btn class="float-right" icon @click="showModuleInfo = true" v-on="on">
								<v-icon color="primary">info_outline</v-icon>
							</v-btn>
						</template>
						<span>Info</span>
					</v-tooltip>
				</v-row>
				<v-dialog v-model="showModuleInfo" width="40%">
					<v-card>
						<v-card-title class="title primary--text mb-2 secondary">
							<translate>Module Info</translate>
							<span class="mx-1">-</span>
							{{module.name}}
						</v-card-title>
						<v-card-text class="my-12">{{module.info}}</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary" text @click="showModuleInfo = false">
								<translate>Close</translate>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-card-title>
			<v-card-actions>
				<template v-if="owned">
					<!-- <v-tooltip v-if="!onlyOne" key="deactivate" top>
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" v-if="owned" :class="$vuetify.breakpoint.mdAndDown ? 'text-caption' : ''" key="deactivate" color="primary" icon @click="deactivateModule">
								<v-icon color="primary">mdi-eye-off</v-icon>
							</v-btn>
						</template>
						<translate>Hide</translate>
					</v-tooltip> -->
					<v-btn color="primary darken-1" text @click="deactivateModule" key="deactivate">
						<translate>Deactivate</translate>
					</v-btn>
				</template>
				<template v-else>
					<v-btn color="primary darken-1" text @click="activateModule" key="activate">
						<translate>Activate</translate>
					</v-btn>
					<!-- <v-tooltip v-else key="activate" top>
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" :class="$vuetify.breakpoint.mdAndDown ? 'text-caption' : ''" key="activate" color="primary" icon @click="activateModule" :disabled="!$store.getters.hasPlan">
								<v-icon color="primary">mdi-eye</v-icon>
							</v-btn>
						</template>
						<span v-translate>Activate</span>
					</v-tooltip> -->
				</template>
				<v-spacer></v-spacer>
				<v-tooltip v-if="owned" top>
					<template v-slot:activator="{ on }">
						<v-btn class="float-right" icon @click="getTerapeuts(); showManageAccess = true" v-on="on">
							<v-icon color="primary">mdi-account-group</v-icon>
						</v-btn>
					</template>
					<span v-translate>Manage Access</span>
				</v-tooltip>
				<v-chip small v-if="module.free">
					<translate>Free</translate>
				</v-chip>
				<v-dialog v-if="owned" v-model="showManageAccess" width="40%">
					<v-card :loading="loadingManageAccess">
						<v-card-title class="title primary--text mb-2 secondary" v-translate>Module Access</v-card-title>
						<v-card-text>
							<p v-translate class="text-subtitle-1 mb-1">Professionals with access</p>
							<p
								v-if="module.terapeuts_in.length == 0"
								class="font-weight-thin ml-2 my-2"
								key="no-selected"
								v-translate
							>No professionals selected.</p>
							<v-list v-else flat>
								<v-list-item
									:key="terapeut.id"
									style="border: 1px solid #e0e0e0; border-radius: 5px"
									v-for="terapeut in module.terapeuts_in"
								>
									<v-list-item-icon class="mr-3">
										<v-icon :color="terapeut.color">person</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											<strong>{{terapeut.name}}</strong>
										</v-list-item-title>
										<v-list-item-subtitle></v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn v-if="$store.getters.userId != terapeut.id" icon @click="removeTerapeut(terapeut)" :disabled="loadingManageAccess">
											<v-icon color="primary">mdi-close-circle</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list>
							<p class="text-subtitle-1 mb-1" v-translate>Other professionals</p>
							<p
								v-if="module.terapeuts_out.length == 0"
								class="font-weight-thin ml-2 my-2"
								key="no-more"
								v-translate
							>No more professionals.</p>
							<v-list flat>
								<v-list-item
									:key="terapeut.id"
									style="border: 1px solid #e0e0e0; border-radius: 5px"
									v-for="terapeut in module.terapeuts_out"
								>
									<v-list-item-icon class="mr-3">
										<v-icon :color="terapeut.color">person</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											<strong>{{terapeut.name}}</strong>
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn icon @click="addTerapeut(terapeut)" :disabled="loadingManageAccess">
											<v-icon color="primary">mdi-plus-circle</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</v-list>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary" text @click="showManageAccess = false"><translate>Close</translate></v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-if="!owned" v-model="showActivateModule" width="30%">
					<v-card>
						<v-card-title class="title primary--text mb-2 secondary" v-translate>
							Switch Module
						</v-card-title>
						<v-card-text>
							<translate>Since you have the basic plan you can only activate one module. Do you want to switch the current module with</translate> {{module.name}}?
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn color="primary" text @click="showActivateModule = false"><translate>Cancel</translate></v-btn>
							<v-spacer></v-spacer>
							<v-btn color="primary" text @click="showActivateModule = false; activateModule()"><translate>Yes</translate></v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "ModuleCard",
	props: {
		module,
		subscriptionPlans: {
			default: () => []
		},
		spaceParams: {
			default: () => {}
		},
		currentPlan: {
			default: () => {}
		}
	},
	data: () => ({
		showModuleInfo: false,
		showManageAccess: false,
		showMonthPricing: false,
		showActivateModule: false,
		duration: 1,
		selectedPlan: "basic",
		loadingManageAccess: false
	}),
	methods: {
		getTerapeuts() {
			this.loadingManageAccess = true;
			axios
				.get("/modules/" + this.module.id + "/terapeuts")
				.then(response => {
					console.log(response.data);
					this.module.terapeuts_in = response.data.terapeuts_in;
					this.module.terapeuts_out = response.data.terapeuts_out;
					this.loadingManageAccess = false;
				})
				.catch(error => {
					console.log(error);
					this.loadingManageAccess = false;
				})
		},
		addTerapeut(terapeut) {
			if (terapeut) {
				var exist = false;
				for (var i = 0; i < this.module.terapeuts_in.length; i++) {
					if (this.module.terapeuts_in[i].id == terapeut.id) {
						exist = true;
						break;
					}
				}
				if (!exist) {
					this.loadingManageAccess = true;
					const terapeutId = terapeut.id;
					const formData = new FormData();
					formData.append("terapeut_id", terapeutId);
					formData.append("operation", "add");
					axios
						.post("/modules/" + this.module.id + "/terapeuts", formData)
						.then(response => {
							if (response.data.result === "ok") {
								this.module.terapeuts_out.splice(this.module.terapeuts_out.indexOf(terapeut), 1);
								this.module.terapeuts_in.push(terapeut);
							}
							this.loadingManageAccess = false;
						})
						.catch(error => {
							console.log(error);
							this.loadingManageAccess = false;
						});
				}
			}
		},
		removeTerapeut(terapeut) {
			this.loadingManageAccess = true;
			const terapeutId = terapeut.id;
			const formData = new FormData();
			formData.append("terapeut_id", terapeutId);
			formData.append("operation", "remove");
			axios
				.post("/modules/" + this.module.id + "/terapeuts", formData)
				.then(response => {
					if (response.data.result === "ok") {
						this.module.terapeuts_in.splice(this.module.terapeuts_out.indexOf(terapeut), 1);
						this.module.terapeuts_out.push(terapeut);
					}
					this.loadingManageAccess = false;
				})
				.catch(error => {
					console.log(error);
					this.loadingManageAccess = false;
				});
		},
		containsObject(obj, list) {
			var i;
			for (i = 0; i < list.length; i++) {
				if (list[i].id == obj.id) {
					return true;
				}
			}
			return false;
		},
		barColor(module) {
			var percentage = module.percentage;
			if (percentage < 30) {
				return "red lighten-2";
			} else if (percentage < 60) {
				return "orange lighten-2";
			} else {
				return "green lighten-2";
			}
		},
		activateModule() {
			axios
				.post("/modules/" + this.module.id + "/activate")
				.then(response => {
					console.log(response.data);
					if (response.data.result === "ok") {
						this.module.active = true;
						this.$store.dispatch("ADD_MODULE", this.module);
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		deactivateModule() {
			axios
				.post("/modules/" + this.module.id + "/deactivate")
				.then(response => {
					console.log(response.data);
					if (response.data.result === "ok") {
						this.module.active = false;
						this.$store.dispatch("REMOVE_MODULE", this.module);
					}
				})
				.catch(error => {
					console.log(error);
				});
		}
	},
	computed: {
		owned() {
			return this.module.active;
		},
		otherTerapeuts() {
			return this.terapeuts.filter(
				t => !this.containsObject(t, this.module.terapeuts)
			);
		},
		moduleName() {
			if (this.module.code === "mtc")
				return this.$gettext("TCM");
			if (this.module.code === "fito")
				return this.$gettext("Fitotherapy");
			if (this.module.code === "osteo")
				return this.$gettext("Osteopathy");
			if (this.module.code === "base")
				return this.$gettext("Generic");
			return "";
		}
	}
};
</script>